import React from 'react';

const TourBanner = () => {
  const tourMessage = "Currently available in Sydney • Accepting FMTY bookings worldwide";
  
  return (
    <div style={{
      background: 'var(--burgundy)',
      color: 'var(--ivory)',
      overflow: 'hidden',
      padding: '12px 0',
      position: 'relative'
    }}>
      <div style={{
        display: 'flex',
        animation: 'scroll 20s linear infinite',
        whiteSpace: 'nowrap'
      }}>
        {[...Array(4)].map((_, index) => (
          <div
            key={`tour-banner-${index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingRight: '80px',
              fontFamily: 'Raleway, sans-serif',
              fontSize: '14px',
              fontWeight: 400,
              letterSpacing: '1px'
            }}
          >
            <span>{tourMessage}</span>
            <span style={{ 
              margin: '0 40px',
              fontSize: '8px',
              opacity: 0.6
            }}>
              ◆
            </span>
          </div>
        ))}
      </div>
      <style>
        {`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>
  );
};

export default TourBanner;
